import { useTranslation } from "react-i18next";
import { passwordStrength } from "./passwordRules";
import { cn } from "@/lib/utils";

export function PasswordStrength({ value }: { value: string }) {
  const { t } = useTranslation();
  if (!value) return null;
  const s = passwordStrength(value);
  const filled = s === "weak" ? 1 : s === "ok" ? 2 : 3;
  return (
    <div className="flex items-center gap-3" aria-live="polite">
      <div className="flex flex-1 gap-1" aria-hidden="true">
        {[1, 2, 3].map((i) => (
          <span
            key={i}
            className={cn("h-1.5 flex-1 rounded-full", i <= filled ? (s === "weak" ? "bg-fg-subtle" : "bg-accent") : "bg-surface-sunken")}
          />
        ))}
      </div>
      <span className="text-sm text-fg-muted">
        {t("auth.strength.label")}: {t(`auth.strength.${s}`)}
      </span>
    </div>
  );
}
